import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, SubmissionError, reduxForm } from 'redux-form';

import { notify } from '@/actions/ui';
import Form from '@/components/Form';
import { TextField } from '@/components/FormAdapters';
import { APIError, ERROR_CODES, errorMessages, hasErrorCode } from '@/core/api';
import { reportProfileSaveFailure } from '@/profile/profileSaveFailure';
import { updateProfile } from '@/profile/store';
import { normalizeSpace } from '@/utils';

const TOO_LONG_FIELDS: Record<string, string> = {
  [ERROR_CODES.PROFILE_FIRST_NAME_TOO_LONG]: 'first_name',
  [ERROR_CODES.PROFILE_LAST_NAME_TOO_LONG]: 'last_name',
};

function validate(values = {}) {
  const errors = {};

  // @ts-expect-error TS(2339): Property 'first_name' does not exist on type '{}'.
  if (!values.first_name) {
    // @ts-expect-error TS(2339): Property 'first_name' does not exist on type '{}'.
    errors.first_name = 'Required';
  }

  // @ts-expect-error TS(2339): Property 'last_name' does not exist on type '{}'.
  if (!values.last_name) {
    // @ts-expect-error TS(2339): Property 'last_name' does not exist on type '{}'.
    errors.last_name = 'Required';
  }

  return errors;
}

export class NameForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  };

  handleSubmit = async (values: any) => {
    // @ts-expect-error TS(2339): Property 'profileId' does not exist on type 'Reado... Remove this comment to see the full error message
    const { profileId, updateProfile, onSubmit, notify } = this.props;
    const { first_name, last_name } = values;

    await updateProfile({
      id: profileId,
      name: `${first_name} ${last_name}`,
      ...values,
      first_name: first_name.trim(),
      last_name: last_name.trim(),
    }).catch((err: unknown) => {
      // The message must come from the error whose code matched, not the response's first.
      const tooLong =
        err instanceof APIError
          ? err.rawError.find((e) => TOO_LONG_FIELDS[e.extensions?.code as string])
          : undefined;
      if (tooLong) {
        throw new SubmissionError({
          [TOO_LONG_FIELDS[tooLong.extensions?.code as string]]: tooLong.message,
        });
      }
      // One code covers invalid characters in either field; only the message says which.
      if (hasErrorCode(err, ERROR_CODES.PROFILE_INVALID_NAME)) {
        const field = errorMessages(err).join(' ').includes('last name')
          ? 'last_name'
          : 'first_name';
        throw new SubmissionError({ [field]: 'Invalid name' });
      }
      const message = reportProfileSaveFailure(
        err,
        notify,
        'An error occurred when updating the profile.'
      );
      // Without this the catch resolves, onSubmit below still runs, and the Edit Name
      // dialog closes as if the save succeeded — the WEBAPP-CC8 failure mode.
      throw new SubmissionError({ _error: message });
    });

    if (onSubmit) {
      onSubmit(values);
    }
  };

  handleReset = () => {
    // @ts-expect-error TS(2339): Property 'reset' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reset, onReset } = this.props;

    reset();

    if (onReset) {
      onReset();
    }
  };

  render() {
    const {
      // @ts-expect-error TS(2339): Property 'component' does not exist on type 'Reado... Remove this comment to see the full error message
      component: Container = Form,
      // @ts-expect-error TS(2339): Property 'handleSubmit' does not exist on type 'Re... Remove this comment to see the full error message
      handleSubmit,
      ...other
    } = this.props;

    return (
      <Container {...other} onSubmit={handleSubmit(this.handleSubmit)} onReset={this.handleReset}>
        <Field
          component={TextField}
          fullWidth
          name="first_name"
          label="First Name"
          inputProps={{ maxLength: 255 }}
          normalize={normalizeSpace}
        />
        <Field
          component={TextField}
          fullWidth
          name="last_name"
          label="Last Name"
          inputProps={{ maxLength: 255 }}
          normalize={normalizeSpace}
        />
      </Container>
    );
  }
}

const WrappedNameForm = reduxForm({
  form: 'expertName',
  validate,
  enableReinitialize: true,
  // @ts-expect-error TS(2345): Argument of type 'typeof NameForm' is not assignab... Remove this comment to see the full error message
})(NameForm);

export default connect(
  (state, ownProps) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const profile = state.profiles.fullProfiles[ownProps.profileId];
    return {
      profile,
      initialValues: {
        first_name: profile.first_name,
        last_name: profile.last_name,
      },
    };
  },
  {
    updateProfile,
    notify,
  }
)(WrappedNameForm);
